import { ChangeEvent } from "react";
import { textValidate } from "../../../../Utils/regex";
import { ChildProps_logistica_GUIA_PROFORMAviewModel } from "../ContentGuia";
import { StyleProps1, StyleProps2 } from "./styles";



  


const Observacion: React.FC<ChildProps_logistica_GUIA_PROFORMAviewModel> = ({guia,setGuia,vm}) => {

    return (
        <div className="invoice-detail-note">
            <div className="row">
                <div className="col-md-12 align-self-center">
                    <div className="form-group row invoice-note">
                        <label htmlFor="invoice-detail-notes"
                            className="col-sm-12 col-form-label col-form-label-sm" style={StyleProps1}>Observación:</label>
                        <div className="col-sm-12">
                            <textarea className="form-control"
                             id="invoice-detail-notes"
                                placeholder=''
                                 style={StyleProps2}
                                 value={guia.observacion}
                                 onChange={(e) => handleInfo(e)}
                                 >
                                 </textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
    //Esta función nos ayuda a manejar la información que se encuentra dentro del componente     
    function handleInfo (e:ChangeEvent<HTMLTextAreaElement>) {
        const input = e.target.value
            if(textValidate(input)) //pregunta si no incluye caracteres especiales para evitar errores
            setGuia({
                ...guia,
                observacion: input
            })
    }
}





export default Observacion